import types from '@/constants/types'

// initial state
const state = {}
// getters
const getters = {
  getAll: state => state.all
}

// actions
const actions = {
  [types.TEACHER]({
    commit,
    state
  }) {
    setTimeout(() => {
      commit(types.TEACHER, 1)
    }, 1000);
  }
}

// mutations
const mutations = {
  [types.TEACHER](state, status) {
    state.all = status;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/teachers.js